export const openNewTab =  (url) => {
  window.open(url, '_blank');
}
